import { React, useEffect } from "react";
import {
  Container,
  Divider,
  Grid,
  GridColumn,
  GridRow,
  Image,
  Header
} from "semantic-ui-react";
import TimberSelection from "./timberSelction";
import Gallery from "./gallery";

export default function Products(props) {

  useEffect(() => {
    document.title = "Splinters Woodwork | Products"
  }, []);

  const { setSelection } = props

  const h1Style = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "4em",
  }

	const h1StyleMobile = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "3em",
  }

  const h1WhiteStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "4em",
  }

	const h1WhiteStyleMobile = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "3em",
  }

  const pWhiteStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "1.1em",
    lineHeight: "1.4em",
  }

  const dividerStyle = {
    width: "30em", 
    margin: "0 auto",
    border: "0.1em solid #F9F5F5",
    borderRadius: "1em",
  }

  return (
		<div>
      <Grid 
        style={{ 
          backgroundColor: "#C2CDBE",
          margin: "-12em 0em 0em 0em", 
          padding: "12em 0em 5em 0em",
        }}
      >
				<GridRow columns={1} style={{ padding: "0em 0em 4em 0em" }}>
					<GridColumn only="computer tablet" textAlign='center'>
						<Header
							as='h1'
							content='Products'
							style={h1WhiteStyle}
						/>
					</GridColumn>
					<GridColumn only="mobile" textAlign='center'>
						<Header
							as='h1'
							content='Products'
							style={h1WhiteStyleMobile}
						/>
					</GridColumn>
				</GridRow>
      </Grid>

      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em", margin: "-1em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./bottomBreak.svg"
              alt="Decorative bottom break"
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow columns={1} style={{padding: "10em 0em 4em 0em" }}>
          <GridColumn only="computer tablet" textAlign='center'>
            <Header
              as='h2'
              id="gallery-header"
              content='Explore our work'
              style={h1Style}
            />
          </GridColumn>
          <GridColumn only="mobile" textAlign='center'>
            <Header
              as='h2'
              id="gallery-header"
              content='Explore our work'
              style={h1StyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{padding: "4em 0em 10em 0em" }}>
          <GridColumn>
            <Gallery/>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./topBreak.svg"
              alt="Decorative top break"
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow only="computer tablet" style={{backgroundColor: "#C2CDBE", padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              id="who-we-are-header"
              content='Who we are'
              style={h1WhiteStyle}
            />
          </GridColumn>
        </GridRow>
        <GridRow only="mobile" style={{backgroundColor: "#C2CDBE", padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              id="who-we-are-header"
              content='Who we are'
              style={h1WhiteStyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{backgroundColor: "#C2CDBE", padding: "0em 0em 10em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pWhiteStyle}>
              Splinter specialises in quality timber and resin pieces ranging from laminated 
              boards, cheese knives, butter knives, bread knives and wine stoppers to timber 
              & resin boards, lazy susans and custom-made statement pieces of furniture. Each 
              piece of Tasmanian timber is carefully selected and inlaid in various colours to 
              create an exceptional work of art.
            </Container>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./bottomBreak.svg"
              alt="Decorative bottom break"
            />
          </GridColumn>
        </GridRow>
      </Grid>


      <Grid>
        <GridRow style={{ padding: "10em 0em 10em 0em" }}>
          <GridColumn>
            <TimberSelection setSelection={setSelection} />
          </GridColumn>
        </GridRow>
      </Grid>


      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./topBreak.svg"
              alt="Decorative top break"
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow only="computer tablet" style={{backgroundColor: "#C2CDBE", padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              id="testimonials-header"
              content='Testimonials'
              style={h1WhiteStyle}
            />
          </GridColumn>
        </GridRow>
        <GridRow only="mobile" style={{backgroundColor: "#C2CDBE", padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              id="testimonials-header"
              content='Testimonials'
              style={h1WhiteStyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{backgroundColor: "#C2CDBE", padding: "0em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pWhiteStyle}>
              “We purchased a huon pine coffee table with resin insert - it is an amazing, unique 
              piece of Tasmania for us to keep forever that John has created."
            </Container>
            <br/>
            <Container style={pWhiteStyle}>
              Darin & Tracie Y.
            </Container>
            <br/>
            <Divider style={dividerStyle} />
          </GridColumn>
        </GridRow>

        <GridRow style={{backgroundColor: "#C2CDBE", padding: "0em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pWhiteStyle}>
              “Absolutely beautiful work. John is an amazing craftsman. Gorgeous timber made into 
              beautiful works of art."
            </Container>
            <br/>
            <Container style={pWhiteStyle}>
              Jennie & Michael D.
            </Container>
            <br/>
            <Divider style={dividerStyle} />
          </GridColumn>
        </GridRow>

        <GridRow style={{backgroundColor: "#C2CDBE", padding: "0em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pWhiteStyle}>
              "We met the maker and his wife today, truly lovely people who make the most amazing 
              quality woodwork. Passionate about their product , and this shines through in the 
              end result. John and Judy, thank you for the wonderful gifts we have bought to 
              take back to WA. Unique in every way and made with love."
            </Container>
            <br/>
            <Container style={pWhiteStyle}>
              Sally & Larry H.
            </Container>
            <br/>
            <Divider style={dividerStyle} />
          </GridColumn>
        </GridRow>

        <GridRow style={{backgroundColor: "#C2CDBE", padding: "0em 0em 10em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pWhiteStyle}>
              "John is extremely talented, and his work is as beautiful as the fine heritage 
              Tasmanian timbers he uses."
            </Container>
            <br/>
            <Container style={pWhiteStyle}>
              Anne R.
            </Container>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./bottomBreak.svg"
              alt="Decorative bottom break"
            />
          </GridColumn>
        </GridRow>
      </Grid> 
    </div>
  )
}